export const TIME_INTERVAL = 2000;
